'use strict';

angular.module('licensure.services')
    .factory('LicenseRequestFBResponses', ['$http', '$q', function ($http, $q) {

        return {
            save: function (licenseRequestResponse, formID) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/LicenseRequestFBResponses/';
                if (!isUndefined(licenseRequestResponse.id)) {
                    method = 'PUT'
                    url += licenseRequestResponse.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        license_request_response: licenseRequestResponse,
                        form_id: formID
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        };
    }])
;